var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-detail-item flex",style:({'width': _vm.mobile || _vm.full ? '100%' : '50%'})},[_c('label',{staticClass:"c-detail-item-label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"c-detail-item-content flex-grow"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }